import { createStyles, Badge } from '@mantine/core';
import React, { useState } from 'react';
import { foodCategoryColor } from '../utils/detailsData';
import { foodCategoryType } from '../utils/Types/enumType';

const useStyle = createStyles((theme) => ({
  circle: {
    borderRadius: '50%',
    width: '7px',
    height: '7px',
    padding: 0,
  },
}));

interface FoodCategoryProps {
  category: any;
}

const IndicatorIcon = ({ category }: FoodCategoryProps) => {
  const { classes } = useStyle();
  const [categoryType, setCategoryType] = useState(Object.keys(foodCategoryType).filter((v) => isNaN(Number(v))));

  return (
    <>
      {categoryType.length > 0 &&
        categoryType.map((item, id) => (
          <React.Fragment key={id}>
            {item === category && <Badge key={id} className={classes.circle} bg={foodCategoryColor[id]}></Badge>}
          </React.Fragment>
        ))}
    </>
  );
};

export default IndicatorIcon;
